import { useMutation } from '@tanstack/react-query';

import { queryClient } from '~app/query-client';

import { type StudentForm } from '~entities/student';

import { baseAPI } from '~shared/api/base-api';
import { KEYS } from '~shared/api/query-keys';

import type { Student } from '../modal/student';

export interface UpdateStudentByIdParams extends StudentForm {
  studentId: string;
}

export const updateStudentById = async ({
  studentId,
  ...params
}: UpdateStudentByIdParams) => {
  const response = await baseAPI.post<Student>(
    `/studios/update/student/${studentId}`,
    params,
  );
  return response.data;
};

export const useUpdateStudentByIdMutation = () => {
  return useMutation({
    mutationFn: (params: UpdateStudentByIdParams) => updateStudentById(params),
    onSuccess: (_, y) => {
      const studentId = y.studentId;
      // Invalidate the specific student query
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDENTS, studentId],
      });
      // Invalidate all student list queries (including search/filtered lists)
      void queryClient.invalidateQueries({
        queryKey: [KEYS.STUDENTS],
      });
      // Attendance rosters surface photoOptOut / name / dob for this student
      void queryClient.invalidateQueries({
        queryKey: [KEYS.ATTENDANCE],
      });
    },
  });
};
